import React from 'react';
import './App.css';
import {
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Sidebar from './utils/sidebar'
import { Layout, message, Button } from 'antd'
import AddEntre from './factures/components/add'
import AddSortie from './factures/components/sorties/add'
import Customers from './customers'
import TableEntree from './factures/components';
import TableDevise from './devises';
import AddDevise from './devises/components/form';
import AddClient from './customers/components/forms';
import TableSortie from './factures/components/sorties/'
import FactureEntreeForValidate from './factures/components/entrevalidate'
import FactureSortieForValidate from './factures/components/sorties/sortievalidate'
import Users from './users';
import AddUsers from './users/components/form'
import RapportFacture from './factures/components/rapport'
import Retrait from './factures/components/retrait';
import Depot from './factures/components/depot';
import CompteClient from './factures/components/compteClient';
import EditDepot from './factures/components/updateOperation';
import TableTaux from './taux_jour';
import AddTaux from './taux_jour/components/form';
import TableDepense from './depenses/';
import TableIjectFond from './depenses/components/inject_fond';
import Rapport from './rapports'
import EditDepense from './depenses/components/edit';
import SoldesBureau from './rapports/soldes_bureau'
import ByClientInBureau from './rapports/in_bureau'
import ByClientHorsBureau from './rapports/hors_bureau'
import TableValidateDepot from './operations/validateDepot'
import TableValidateRetrait from './operations/validateRetrait'
import Login from './auth/login'
import axios from './services/axios'
import Dashboard from './dashboard';
import Benefices from './benefices';
import Transation_by_client from './rapports/transation_by_client';
import RapportCreditPdf from './rapports/rapport_credit_dette_pdf';
import  { PRIMARY_COLOR } from './utils/constants'
import { isAgent, isPathAllowedForAgent } from './utils/constants/access';
const { Header, Content, Footer, Sider } = Layout;

function App() {
  const [user, setUser] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isRedirect, setRedirect] = React.useState(false);

  React.useEffect(() => {
    fetchUserConnected();
  }, []);

  async function fetchUserConnected() {
    try {
      const validate = localStorage.getItem('valideUser');
      const token = localStorage.getItem('token-bahtb-secret');
     
      if (token && validate == 'dms-valide') {
        setUser(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  function signIn(values: any) {
    setLoading(true)
    try {
      axios.post('/login', values)
        .then(function (response) {
          localStorage.setItem('token-bahtb-secret', response.data.access_token);
          localStorage.setItem('valideUser', 'dms-valide');
          localStorage.setItem('role-bahtb-secret', response.data.role || '');
          setRedirect(true)
          setUser(response.data);
        })
        .catch(function (error) {
          console.log(error);
          message.error('Identifiant ou mot de passe incorrect!');
          setLoading(false);
        });
    } catch (error) {
      message.error('Identifiant ou mot de passe incorrect!');
      console.log('error', error);
    }
  }

  const logout = () => {
    localStorage.setItem('token-bahtb-secret', '');
    localStorage.setItem('valideUser', '');
    localStorage.setItem('role-bahtb-secret', '');
    setUser(false)
    setLoading(false)
    window.location.href = '/';
  }

  const location = useLocation();

  return (
    <>
      {!user ? (<Login onSubmit={signIn} isLoading={loading} />) : (
        <Layout style={{ minHeight: '100vh', overflow: 'hidden' }}>
          <Sider
            style={{ backgroundColor: PRIMARY_COLOR}}
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={broken => {
              console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              console.log(collapsed, type);
            }}>
            <Sidebar />
          </Sider>

          <Layout style={{ overflow: 'hidden' }}>
            <Header 
              className="site-layout-sub-header-background responsive-header" 
              style={{ 
                padding: '0 16px', 
                backgroundColor: PRIMARY_COLOR,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                height: '64px'
              }} 
            >
              <Button 
                type='primary' 
                danger 
                onClick={logout}
                className="logout-button"
              >
                <span className="logout-text-full">Se déconnecter</span>
              </Button>
            </Header>

            <Content 
              style={{ 
                margin: '16px', 
                overflow: 'auto',
                maxWidth: '100%'
              }}
              className="responsive-content"
            >
              <div 
                className="site-layout-background" 
                style={{ 
                  padding: 24, 
                  minHeight: 'calc(100vh - 134px)', 
                  background: '#fff',
                  overflow: 'auto'
                }}
              >
                {isAgent() && !isPathAllowedForAgent(location.pathname) ? (
                  <Navigate to="/depot" replace />
                ) : (
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/clients" element={<Customers />} />
                  <Route path="/clients/edit/:id" element={<AddClient />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/devises" element={<TableDevise />} />
                  <Route path="/add-devise" element={<AddDevise />} />
                  <Route path="/add-devise/edit/:id" element={<AddDevise />} />
                  <Route path="/add-clients" element={<AddClient />} />
                  <Route path="/entrees/valide" element={<FactureEntreeForValidate />} />
                  <Route path="/utilisateurs" element={<Users />} />
                  <Route path="/add-users" element={<AddUsers />} />
                  <Route path="/add-users/edit/:id" element={<AddUsers />} />
                  <Route path="/comptes-globales" element={<RapportFacture />} />
                  <Route path="/retrait" element={<Retrait />} />
                  <Route path="/depot" element={<Depot />} />
                  <Route path="/benefices" element={<Benefices />} />
                  <Route path="/depot/edit/:id" element={<EditDepot />} />
                  <Route path="/compte-client" element={<CompteClient />} />
                  <Route path="/taux-jours" element={<TableTaux />} />
                  <Route path="/add-taux-jours" element={<AddTaux />} />
                  <Route path="/add-taux-jour/edit/:id" element={<AddTaux />} />
                  <Route path="/depenses" element={<TableDepense />} />
                  <Route path="/inject-fond" element={<TableIjectFond />} />
                  <Route path="/depenses/edit/:id" element={<EditDepense />} />
                  <Route path="/rapports/credits" element={<Rapport />} />
                  <Route path="/rapports/soldes-bureau" element={<SoldesBureau />} />
                  <Route path="/rapports/clients/in-bureau" element={<ByClientInBureau />} />
                  <Route path="/rapports/clients/hors-bureau" element={<ByClientHorsBureau />} />
                  <Route path="/rapports/all-transations/by-client" element={<Transation_by_client />} />
                  <Route path="/rapports/rapport-credit-pdf" element={<RapportCreditPdf />} />
                  <Route path="/rapports/rapport-credit-pdf/by-client/:idclient" element={<RapportCreditPdf />} />
                  <Route path="/rapports/rapport-credit-pdf/by-devise/undefined/:iddevise" element={<RapportCreditPdf />} />
                  <Route path="/rapports/rapport-credit-pdf/:idclient/:iddevise" element={<RapportCreditPdf />} />
                </Routes>
                )}
              </div>
            </Content>
            
            <Footer 
              style={{ 
                textAlign: 'center',
                padding: '16px 8px'
              }}
              className="responsive-footer"
            >
              <div className="footer-content">
                <span className="footer-copyright">
                  Copy right ©{new Date().getFullYear()} Created by <a target="_blank" href="https://bimapgroup.com">Bimap group</a>
                </span>
              </div>
            </Footer>
          </Layout>
        </Layout>
      )}
    </>
  );
}

export default App;